var __rspack_ns_object = JSON.parse('{"Measurements":"Measurements","Studies":"Studies"}')